import dayjs from 'dayjs';
import parse,{attributesToProps,domToReact} from 'html-react-parser';
import Image from 'next/image';

import { cardColors, textColors } from '@/src/constants/wall.constant';
import {socialCardKeys} from '@/src/constants/socialcard.constant'
import ClassNames from '@/src/components/componentHelper/ClassNames';
import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const TweetLike = () => (
   <svg
    id="Layer_1"
    enableBackground="new 0 0 620.767 589.535"
    viewBox="0 0 620.767 589.535"
    version="1.1"
    y="0px"
    x="0px"
    width="20px"
    height="20px"
    style={{margin:'auto'}}
  >
<g>
	<g>
		<path
          d="m390.5 116.59c5.646 0 11.67 0.303 18.075 0.923 39.136 3.823 84.396 39.641 89.915 108.29v22.847c-5.114 65.715-54.73 146.76-199.7 248.43-144.98-101.68-194.59-182.72-199.7-248.43v-22.847c5.516-68.649 50.727-104.47 89.863-108.29 6.428-0.62 12.453-0.923 18.098-0.923 45.209 0 66.905 19.529 91.737 49.12 24.83-29.59 46.5-49.12 91.7-49.12m0 43.68c-25.97 0-36.805 7.963-58.245 33.516l-33.464 39.882-33.49-39.882c-21.416-25.553-32.251-33.516-58.247-33.516-4.254 0-8.912 0.241-13.847 0.723-18.072 1.757-46.171 20.996-50.424 66.7v19.125c5.316 57.374 57.765 123.38 156.01 196.41 98.241-73.04 150.69-139.03 156.01-196.41v-19.13c-4.277-45.691-32.401-64.943-50.424-66.7-4.97-0.48-9.63-0.72-13.89-0.72z"
          fill="#FF151B"
      />
	</g>
</g>
  </svg>
)

const TweetReply = () => (
   <svg style={{margin:'auto'}} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"  width="18px" height="15px">
  <path fill="var(--ci-primary-color, currentColor)" d="M496,496H480a273.39,273.39,0,0,1-179.025-66.782l-16.827-14.584C274.814,415.542,265.376,416,256,416c-63.527,0-123.385-20.431-168.548-57.529C41.375,320.623,16,270.025,16,216S41.375,111.377,87.452,73.529C132.615,36.431,192.473,16,256,16S379.385,36.431,424.548,73.529C470.625,111.377,496,161.975,496,216a171.161,171.161,0,0,1-21.077,82.151,201.505,201.505,0,0,1-47.065,57.537,285.22,285.22,0,0,0,63.455,97L496,457.373ZM294.456,381.222l27.477,23.814a241.379,241.379,0,0,0,135,57.86,317.5,317.5,0,0,1-62.617-105.583v0l-4.395-12.463,9.209-7.068C440.963,305.678,464,262.429,464,216c0-92.636-93.309-168-208-168S48,123.364,48,216s93.309,168,208,168a259.114,259.114,0,0,0,31.4-1.913Z" className="ci-primary"/>
</svg>
)

const TwitterCard = ({ cardItem, cardWidth, fontStyle,cardBackgroundObject, darkModeEnabled=false,cardFontColor,linkColor, highlightColor, darkCardTheme, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled, ratingColor}) => {
   const getTextColor = () => (cardFontColor ? cardFontColor : (!darkModeEnabled ? textColors.black.primary : textColors.light.primary));
   const getSecondaryTextColor = () => (cardFontColor ? cardFontColor : (!darkModeEnabled ? textColors.black.secondary : textColors.light.secondary));

   const options = {
      replace: domNode => {
         const attribProps = attributesToProps(domNode.attribs);

         if (domNode.name === 'a') {
            return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
         }
         else if(domNode.name === 'b'){
            let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
            if (darkModeEnabled) {
              bStyle.color = '#726c6c';
            }
            return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
         }
      }
   }

   

   return(
         <div className={ClassNames(darkModeEnabled ? "border-none" : "border border-gray-200 bg-white", "relative z-0 transition-all w-full card-holder ")} style={{maxWidth: "40rem",minWidth:cardWidth}}>
         <div 
         className="card social-card-style select-none relative transition-all"
         style={cardBackgroundObject? 
            cardBackgroundObject:
            {}
         }
         >
           
           <div className={ClassNames("w-full flex padding-bottom--lg padding-bottom--lg",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')}>
               <div style={{minWidth:'48px'}}><a href={cardItem[socialCardKeys.authorLink]} target="_blank" rel="noreferrer noopener">
               {
                     cardItem[socialCardKeys.authorImage]?
                  <Image priority={true}  src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }} />
                  :
                  <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }}/>
                  }                  
                  </a></div>
               <div className="flex-grow pl-3">
                  <div className="flex justify-between">
                     <div>
                        <h6 className="font-bold text-md inline-flex">
                           <a className='cursor-pointer' href={cardItem[socialCardKeys.authorLink]} style={{ fontWeight: 600, color: getTextColor(), lineHeight: 1.2, textDecoration: 'none',marginRight: '5px'  }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.authorName]}</a>
                           {cardItem[socialCardKeys.authorIsVerifiedBadge] && <Image src={'/TwitterVerified.svg'} alt="" width="18px" height="18px" style={{ marginTop: '2px', marginLeft: '5px' }} />}
                        </h6>
                     </div>
                     <div style={{minWidth:'20px'}}>
                        <a className='cursor-pointer' href={cardItem[socialCardKeys.messageLink]} target="_blank" rel="noreferrer noopener">
                        <svg
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
      width={20}
      height={20}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
    </svg>
                

                        </a>
                     </div>
                  </div>
                  { (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='')  ?
         <div className="text-sm cursor-pointer">
         <a style={{ color: getTextColor(), fontSize: '13.5px' }} className={!darkModeEnabled ? 'text-gray-700' : 'text-gray-300'} href={cardItem[socialCardKeys.authorLink]} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a>
         </div>
        :
              (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!=='') ?
              <div className="text-sm cursor-pointer">
               <a style={{ color: getTextColor(), fontSize: '13.5px' }} className={!darkModeEnabled ? 'text-gray-700' : 'text-gray-300'} href={cardItem[socialCardKeys.authorLink]} target="_blank" rel="noreferrer noopener">@{cardItem[socialCardKeys.authorUsername]}</a>
               </div>
                :
                null
        }
                       </div>
            </div>

            <div className="tweet-content" style={{ color: getTextColor(), fontSize: !smallSize ? "1.15em" : "1.0em", lineHeight: !smallSize ? 1.5 : 1.7 }}>
            <div className={ClassNames("content",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} dir="auto">
               {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
               </div>
               {
                  cardItem[socialCardKeys.messageMediaImage] ?
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                     <img loading='lazy' className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius:'10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Tweet Image" />

                  </div>
                  :
                  cardItem[socialCardKeys.messageVideoThumbnail] ?
                  <div className='relative'>
                  <a className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}} href={cardItem[socialCardKeys.messageLink]} target="_blank" rel="noreferrer noopener">


                  {/* <img className="h-45 w-auto" loading='lazy' style={{ width: '100%', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageVideoThumbnail]} alt="Video" /> */}

                  <img loading='lazy' className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius: '10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageVideoThumbnail]} alt="Video" />


                  <div
  aria-label="Play this video"
  role="button"
  tabIndex={0}
  style={{position:'absolute',left: 0, right: 0, top:0, bottom: 0, marginLeft: 'auto', marginRight: 'auto',WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",flexDirection:"column",backgroundColor: 'rgb(29, 155, 240)', outlineStyle:'none', borderWidth:'4px', borderColor: 'rgb(29, 155, 240)', width:'30px', height: '30px', borderRadius:"9999px",borderStyle:"solid",MsFlexAlign:"stretch",MsFlexDirection:"column",MsFlexNegative:"0",MsFlexPreferredSize:"auto",WebkitAlignItems:"stretch",WebkitBoxAlign:"stretch",WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",WebkitFlexBasis:"auto",WebkitFlexDirection:"column",WebkitFlexShrink:"0",alignItems:"stretch",border:"0 solid black",boxSizing:"border-box",display:"flex",flexBasis:"auto",flexDirection:"column",flexShrink:"0",marginBottom:"auto",marginTop:"auto",minHeight:"0px",minWidth:"0px",paddingBottom:"0px",paddingLeft:"0px",paddingRight:"0px",paddingTop:"0px",zIndex:"0"}}
>
  <div style={{position:'absolute', WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",flexDirection:"column",WebkitBoxAlign:"center",alignItems:"center",WebkitBoxPack:"center",justifyContent:"center",height:"100%",width:"100%", MsFlexAlign:"stretch",MsFlexDirection:"column",MsFlexNegative:"0",MsFlexPreferredSize:"auto",WebkitAlignItems:"stretch",WebkitBoxAlign:"stretch",WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",WebkitFlexBasis:"auto",WebkitFlexDirection:"column",WebkitFlexShrink:"0",alignItems:"stretch",border:"0 solid black",boxSizing:"border-box",display:"flex",flexBasis:"auto",flexDirection:"column",flexShrink:"0",marginBottom:"0px",marginLeft:"0px",marginRight:"0px",marginTop:"0px",minHeight:"0px",minWidth:"0px",paddingBottom:"0px",paddingLeft:"0px",paddingRight:"0px",paddingTop:"0px",position:"relative",zIndex:"0"}}>
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{paddingLeft:"3px",marginLeft:'auto',marginRight:'auto',width:"calc(50% + 4px)",color:"rgb(255, 255, 255)",MozUserSelect:"none",MsUserSelect:"none",WebkitUserSelect:"none",userSelect:"none",verticalAlign:"text-bottom",position:"relative,\nheight: calc(50% + 4px)",maxWidth:"100%",fill:"currentcolor",display:"inline-block"}}
    >
      <g>
        <path d="M21 12L4 2v20l17-10z" />
      </g>
    </svg>
  </div>
</div>
               </a>
               </div>
               :
               null
               }
            </div>


            
            <div>
            <div className="flex">
                     {
                        !engagementDisabled &&
                        <>
                           <div className={ClassNames("whitespace-nowrap flex space-x-1 social-engagement",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: getSecondaryTextColor(), marginRight: 16, fontSize: 14 }}><TweetLike /><span className="font-normal" style={{ color: getSecondaryTextColor() }}>{cardItem[socialCardKeys.likesCount]}</span></div>
                           <div className={ClassNames("whitespace-nowrap flex space-x-1 social-engagement",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: getSecondaryTextColor(), marginRight: 16, fontSize: 14 }}><TweetReply /><span className="font-normal" style={{ color: getSecondaryTextColor() }}>{cardItem[socialCardKeys.commentsCount]}</span></div>
                        </>
                     }
                     <div style={{ color: getSecondaryTextColor(), fontSize: 14 }}>
                        <span className={fontStyle && fontStyle!==''?`font-${fontStyle}`:''}>{(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ? dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY') : null}</span>
                     </div>
                  </div>
            </div>
         </div>
         </div>
      )
   }

export default TwitterCard;

